import {
	useState,
	useEffect
} from 'react'
import {
	useDispatch,
	useSelector
} from 'react-redux'
import {
	envAwarePost
} from '../../../util/util'
import {
	updateParticipants,
	selectShowParticipants,
	selectParticipantsClassId
} from '../liveClassesSlice'

import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'

const ParticipantsModal = ()=>{
	const dispatch = useDispatch()
	const show = useSelector(selectShowParticipants)
	const id = useSelector(selectParticipantsClassId)
	const [participants,setParticipants] = useState([])
	const [status,setStatus] = useState('idle')
	const onHide = ()=>{
		dispatch(updateParticipants({
			show:false,
			id:null
		}))
	}
	useEffect(()=>{
		if(!id){
			//clear participants when closing
			setParticipants([])
		}else{
			setStatus('pending')
			//fetch participants when opening
			envAwarePost(
				'api/trainer-gym/live/classParticipants/',
				{class_id:id}
			).then(res=>{
				setStatus('idle')
				setParticipants(res.data)
			})
		}
	},[id])
	return (
		<Modal show={show} onHide={onHide} centered>
			<Modal.Header closeButton>
				Participants
			</Modal.Header>
			<Modal.Body>
				{
					status === 'idle' ?
					(
						participants.length > 0 ?
						participants.map(p=><div>{p}</div>) :
						<div>No participants</div>
					)
					:
					<Spinner animation="border" variant="primary"/>
					
				}
			</Modal.Body>
		</Modal>
	)
}

export default ParticipantsModal